import { GetApp } from "../../App"
import { BlockField, BlockRow } from "../../Components/Block"
import { PrintListBlock } from "../../Components/PrintListBlock"
import { predefined, PrintShipViewData } from "./Context"
import { PrintShipInsurancesViewProps } from "./Params"

// Insurance policies (only rendered when at least one is present).
export function PrintShipInsurancesView({ data }: PrintShipInsurancesViewProps) {
  const app = GetApp();
  const t = app.getT("ShipDataView");
  const { shipData } = PrintShipViewData.resolveShipData(data);

  const visible = !!(shipData?.insurances && shipData.insurances.length > 0);

  return (
    <PrintListBlock title={t("insurances")} visible={visible}>
      {shipData?.insurances && shipData.insurances.length > 0 && shipData.insurances.map((insurance, index) => (
        <BlockRow key={insurance.id || index} className="block-row-one-row-list">
          <BlockField label={t("insurance_type")} className="block-field-150">{insurance.insuranceType ? (predefined.insuranceType.includes(insurance.insuranceType) ? t(`insurance_${insurance.insuranceType}`) : insurance.insuranceType) : insurance.insuranceType}</BlockField>
          <BlockField label={t("insurance_company")} className="block-field-240">{insurance.insuranceCompany}</BlockField>
          <BlockField label={t("insurance_number")} className="block-field-240">{insurance.insuranceNumber}</BlockField>
        </BlockRow>
      ))}
    </PrintListBlock>
  );
}
